import { type AnyFieldApi } from '@tanstack/react-form';

type FieldInfoProps = {
  field: AnyFieldApi;
};

export function FieldInfo({ field }: FieldInfoProps) {
  return (
    <>
      {field.state.meta.isTouched && !field.state.meta.isValid ? (
        <em>
          {field.state.meta.errors.map(({ message }: { message: string }) => (
            <div key={message} className="text-xs text-red-500">
              {message}
            </div>
          ))}
        </em>
      ) : null}
    </>
  );
}
